import React from 'react'
import { Link } from 'gatsby'
import { Container } from '../ui/container'
import verbatimLogo from '../verbatim_logo.png'

const footerLinks = [
  { label: 'Home', to: '/#home' },
  { label: 'Partners', to: '/#partners' },
  { label: 'FAQ', to: '/#faq' },
  { label: 'Research', to: '/research/' },
  { label: 'Privacy Policy', to: '/privacy/' },
  { label: 'Terms & Conditions', to: '/terms/' },
]

export function Footer() {
  return (
    <footer className="bg-body">
      <div className="h-0.5 w-full bg-[linear-gradient(90deg,transparent,rgba(var(--color-primary)/0.25),rgba(var(--color-secondary)/0.25),transparent)]" />
      <Container className="py-10">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div className="max-w-md">
            <Link to="/#home" className="inline-flex items-center gap-2">
              <img
                src={verbatimLogo}
                alt="Verbatim"
                width={116}
                height={36}
                className="h-8 w-auto sm:h-9"
              />
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-text">
              Skip the survey. Find out what matters. Run real interviews with hundreds of people
              and discover what they actually think.
            </p>
          </div>

          <div className="md:text-right">
            <p className="font-semibold text-foreground">Sitemap</p>
            <div className="mt-3 flex flex-col gap-2 md:items-end">
              {footerLinks.map((l) => (
                <Link key={l.label} to={l.to} className="text-sm text-text hover:text-primary">
                  {l.label}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-primary/10 pt-6 text-sm text-text sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Verbatim by RubidiumData. All rights reserved.</p>
          <p>Give everyone their say.</p>
        </div>
      </Container>
    </footer>
  )
}
